import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { ApprovalComponent } from './approval/approval.component';
import { ApprovalSmartComponent } from './approval-smart/approval-smart/approval-smart.component';
import { CommonModule } from '@angular/common';
import { RestrictedRadioModule } from 'app/components/restricted-radio/restricted-radio.module';
import { RestrictedSliderModule } from 'app/components/restricted-slider/restricted-slider.module';
import { RestrictedInputModule } from 'app/components/restricted-input/restricted-input.module';
import { DiscreteSliderModule } from 'app/components/discrete-slider/discrete-slider.module';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { LocTermApprovalComponent } from './loc-term-approval/loc-term-approval.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatChipsModule } from '@angular/material/chips';
import { ApprovalMenuComponent } from './approval-menu/approval-menu.component';
import { KebabcasePipe } from '../pipes/kebabcase/kebabcase.pipe';
import { ApprovalMenuSmartComponent } from './approval-menu-smart/approval-menu-smart.component';
import { ApprovalSnackBarDataComponent } from './approval-snack-bar-data/approval-snack-bar-data.component';
import { FinancingValuePropsModule } from 'app/financing-value-props/financing-value-props.module';
import { RecommendOptionToggleModule } from 'ng2-app/components/recommend-option-toggle/recommend-option-toggle.module';
import { DeclineInfoDialogModule } from 'ng2-app/components/decline-info-dialog/decline-info-dialog.module';
import { DeclineReasonsDialogModule } from 'ng2-app/components/decline-reasons/decline-reasons-dialog.module';

@NgModule({
  declarations: [
    ApprovalComponent,
    ApprovalSmartComponent,
    LocTermApprovalComponent,
    ApprovalMenuComponent,
    KebabcasePipe,
    ApprovalMenuSmartComponent,
    ApprovalSnackBarDataComponent,
  ],
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatCardModule,
    MatChipsModule,
    MatTableModule,
    MatMenuModule,
    MatSelectModule,
    CommonModule,
    RestrictedRadioModule,
    RestrictedSliderModule,
    RestrictedInputModule,
    DiscreteSliderModule,
    RouterModule,
    FinancingValuePropsModule,
    RecommendOptionToggleModule,
    DeclineInfoDialogModule,
    DeclineReasonsDialogModule,
  ],
  exports: [ApprovalSmartComponent, ApprovalMenuSmartComponent],
})
export class ApprovalModule { }
